import React, { memo } from 'react'
import { Tag } from 'antd'
import { attempt, get } from 'lodash'
import PropTypes from 'prop-types'

const LazyTreeSelectTag = memo(
  ({
    value,
    groupedFlatTreeDataByValue,
    isAllChildrenSelected,
    onClose,
    onFocus,
    ...rest
  }) => (
    <Tag
      onClose={event => {
        attempt(onFocus)
        onClose(event)
      }}
      color={!isAllChildrenSelected ? 'orange' : undefined}
      {...rest}
    >
      {get(groupedFlatTreeDataByValue, `${value}[0].title`)}
    </Tag>
  ),
)

LazyTreeSelectTag.propTypes = {
  value: PropTypes.string.isRequired,
  groupedFlatTreeDataByValue: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  isAllChildrenSelected: PropTypes.bool,
  onFocus: PropTypes.func,
}

LazyTreeSelectTag.defaultProps = {
  onFocus: undefined,
  isAllChildrenSelected: false,
  groupedFlatTreeDataByValue: {},
}

export default memo(LazyTreeSelectTag)
